export default {
  title: {
    id: 'us_telco_comparators_landing_page_faq_title',
    defaultMessage: "FAQ's",
  },
  subtitle: {
    id: 'us_telco_comparators_landing_page_faq_subtitle',
    defaultMessage: 'Frequently asked questions and answers.',
  },
  question1Title: {
    id: 'us_telco_comparators_landing_page_faq_question_1_title',
    defaultMessage: 'Can I keep my existing phone number?',
  },
  question1Answer: {
    id: 'us_telco_comparators_landing_page_faq_question_1_answer',
    defaultMessage:
      'Yes! When you sign up, simply choose to transfer your existing number. The carrier will guide you through a quick number-porting process — it usually takes a few minutes and your number stays active throughout.',
  },
  question2Title: {
    id: 'us_telco_comparators_landing_page_faq_question_2_title',
    defaultMessage: 'Are these available for family plans?',
  },
  question2Answer: {
    id: 'us_telco_comparators_landing_page_faq_question_2_answer',
    defaultMessage:
      'Absolutely. All three carriers offer multi-line family plans so you can add lines for everyone in your household. Each line shares the same great network coverage, and you can mix and match data tiers to fit each person.',
  },
  question3Title: {
    id: 'us_telco_comparators_landing_page_faq_question_3_title',
    defaultMessage: 'What networks do these carriers use?',
  },
  question3Answer: {
    id: 'us_telco_comparators_landing_page_faq_question_3_answer',
    defaultMessage:
      'Each carrier runs on one of the major US networks. Visible by Verizon uses the Verizon network, US Mobile lets you choose between Verizon and T-Mobile, and Tello runs on T-Mobile. All three give you nationwide 5G coverage.',
  },
  question4Title: {
    id: 'us_telco_comparators_landing_page_faq_question_4_title',
    defaultMessage: 'How do I get my promo code? ',
  },
  question4Answer: {
    id: 'us_telco_comparators_landing_page_faq_question_4_answer',
    defaultMessage:
      'Your promo code is displayed on this page next to each carrier offer. Just copy it and paste it at checkout on the carrier website. If you do not see a code, click the offer button — the discount may be applied automatically.',
  },
}
